import { COUNTRIES } from "./countries";

// Regions group e-paper countries (e.g. Gulf, India). Managed from the
// E-Paper Settings screen and loaded from the backend by loadEpaperConfig()
// (config/epaperConfig.ts). An agent's region is stored as the region code.
export type Region = {
  id?: number;
  code: string; // lowercase
  name: string;
  isActive: boolean;
  sortOrder: number;
};

// Shape returned by GET epaper-settings/config and /regions.
export type RegionDto = {
  id: number;
  name: string;
  code: string;
  is_active: boolean;
  sort_order: number;
  country_count?: number;
  country_names?: string[];
};

// Live list, active and inactive. Mutated in place by setRegions() so every
// importer sees reloads. Empty until the first load.
export const REGIONS: Region[] = [];

export const setRegions = (rows: RegionDto[]) => {
  if (!Array.isArray(rows)) return;
  REGIONS.splice(
    0,
    REGIONS.length,
    ...rows.map((r) => ({
      id: r.id,
      code: String(r.code || "").toLowerCase(),
      name: r.name,
      isActive: r.is_active !== false,
      sortOrder: Number(r.sort_order ?? 0),
    }))
  );
};

export const findRegion = (value?: string | null): Region | undefined => {
  const v = String(value ?? "").trim().toLowerCase();
  return v ? REGIONS.find((r) => r.code === v) : undefined;
};

// Active region configured for a country code, if any.
export const regionForCountry = (countryCode?: string | null): Region | undefined => {
  const country = COUNTRIES.find((c) => c.code === countryCode);
  const region = findRegion(country?.regionCode);
  return region?.isActive ? region : undefined;
};

// Display name for a stored up_users.region: a region's name, "Others", or
// for older agents "Gulf"/"India" or a country name; "" when none is saved.
export const regionLabel = (value?: string | null): string => {
  const v = String(value ?? "").trim();
  if (!v) return "";
  if (/^others?$/i.test(v)) return "Others";
  const region = findRegion(v);
  if (region) return region.name;
  if (v.toLowerCase() === "gulf") return "Gulf";
  if (v.toLowerCase() === "india") return "India";
  return COUNTRIES.find((c) => c.code === v.toUpperCase())?.name || v;
};
